import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {createLike, deleteLike} from "../../../creators/like";

// import Modal from "../Modal";
// import SignIn from "../../pages/Signin";
import {Button} from "../Button";
import {fetchLikes} from "../../../creators/likes";
import {Can} from "../../../ability-context";
// import EmailValidation from "../SignUpInformation/components/EmailValidation";
import CtaCannot from "../CtaCannot";


class LikeBtn extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            toggleLike: this.props.isLiked || false,
            togglePopup: false,
            toggleModalEmailUnconfirmed : false
        };
        this.handleToggleLike = this.handleToggleLike.bind(this);
        this.modal = this.props.clickCta["like"];
        if(this.props.currentUserId){
            this.props.fetchLikes(this.props.likeType, this.props.parentId);
        }
    };

    handleToggleLike(e) {
        e.stopPropagation();
        if(this.props.currentUserId){
            if (!this.state.toggleLike) {
                this.props.createLike(this.props.likeType, this.props.parentId);
            } else {
                this.props.deleteLike(this.props.likeType, this.props.parentId);
            }
            this.setState({toggleLike: !this.state.toggleLike});
        }
        // else {
        //     this.setState({toggleSignIn: !this.state.toggleSignIn});
        // }
    }

    render(){
        // let currentModal = this.props.currentUser && this.props.currentUser.email && this.props.currentUser.email.verified ? "toggleSignIn" : "toggleModalEmailUnconfirmed";
        return(
            <Fragment>
                <Can action="create" subject="Like" passThrough>
                    {can => {
                        return can ? (
                            <Fragment>
                                <Button className={`btn-likes ${this.props.className || ""}`}
                                        active={this.state.toggleLike}
                                        onClick={(e) => this.handleToggleLike(e)}
                                        icon={this.state.toggleLike ? "heart-full" : "heart-empty"}
                                        content={"J'aime"}/>
                            </Fragment>
                        ) : (
                            <CtaCannot action={"like"} isModal={true} button={{content : "J'aime", icon : this.state.toggleLike ? "heart-full" : "heart-empty", className: `btn-likes ${this.props.className || ""}`}} />
                        )}}
                </Can>

            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,

        totalLikes: state.likes.total,
        clickCta : state.clickCta.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLikes,

    createLike,
    deleteLike
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LikeBtn);